import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';

const MAX_WIDTH = 700;

export default function MaxWidthContainer({ children, style }: any) {
  return (
    <View style={[styles.container, style]}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignSelf: 'center',
    ...(Platform.OS === 'web'
      ? { maxWidth: MAX_WIDTH, marginHorizontal: 'auto' }
      : {}),
    flex: 1,
  },
});
